import {types} from './types';

export const setGetListCurrencyAction = (payload) => {
    return {
        type: types.SET_LIST_CURRENCY,
        payload,
      }
}

